// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/event/activity/v2/extension/listing_component.proto" (package "bianka.event.activity.v2.extension", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { DropdownGroupName } from "../../../../enums/listing/filter/dropdown_group_name";
import { UserInputType } from "../../../../enums/listing/filter/user_input_type";
import { SourceType } from "../../../../enums/listing/filter/source_type";
import { NeoDefaultState } from "../../../../enums/listing/neo_default_state";
import { Toggle } from "../../../../enums/listing/toggle";
import { ViewType } from "../../../../enums/listing/view_type";
import { FiverrContext } from "../../../../enums/listing/fiverr_context";
import { Context } from "../../../../enums/listing/context";
import { Sorter } from "../../../../enums/listing/sorter";
/**
 * Next serial number to be used: 2
 *
 * @generated from protobuf message bianka.event.activity.v2.extension.ListingComponent
 */
export interface ListingComponent {
    /**
     * @generated from protobuf field: bianka.event.activity.v2.extension.ListingComponent.ListingAttributes listing_attributes = 1
     */
    listingAttributes?: ListingComponent_ListingAttributes;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes
 */
export interface ListingComponent_ListingAttributes {
    /**
     * Number of results
     *
     * @generated from protobuf field: int32 results_number = 1
     */
    resultsNumber: number;
    /**
     * Listing's page number
     *
     * @generated from protobuf field: int32 page_num = 2
     */
    pageNum: number;
    /**
     * Listing's sorter
     *
     * @generated from protobuf field: bianka.enums.listing.Sorter sorter = 3
     */
    sorter: Sorter;
    /**
     * Listing's context
     *
     * @generated from protobuf field: bianka.enums.listing.Context context = 4
     */
    context: Context;
    /**
     * Fiverr's context
     *
     * @generated from protobuf field: bianka.enums.listing.FiverrContext fiverr_context = 5
     */
    fiverrContext: FiverrContext;
    /**
     * Listing's view type
     *
     * @generated from protobuf field: bianka.enums.listing.ViewType view_type = 6
     */
    viewType: ViewType;
    /**
     * List of existing toggles in the page
     *
     * @generated from protobuf field: repeated bianka.enums.listing.Toggle toggles_list = 7
     */
    togglesList: Toggle[];
    /**
     * List of all active filters in the current listing
     *
     * @generated from protobuf field: repeated bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.ActiveFilter active_filters = 8
     */
    activeFilters: ListingComponent_ListingAttributes_ActiveFilter[];
    /**
     * List of all filters that were applied in the previous listing (subset of active_filters)
     *
     * @generated from protobuf field: repeated bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.LastlyAppliedFilter lastly_applied_filters = 9
     */
    lastlyAppliedFilters: ListingComponent_ListingAttributes_LastlyAppliedFilter[];
    /**
     * @generated from protobuf oneof: context_attributes
     */
    contextAttributes: {
        oneofKind: "searchAttributes";
        /**
         * Data regarding the search listings
         *
         * @generated from protobuf field: bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes search_attributes = 10
         */
        searchAttributes: ListingComponent_ListingAttributes_SearchAttributes;
    } | {
        oneofKind: "categoryAttributes";
        /**
         * Data regarding the listing's category
         *
         * @generated from protobuf field: bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.CategoryAttributes category_attributes = 11
         */
        categoryAttributes: ListingComponent_ListingAttributes_CategoryAttributes;
    } | {
        oneofKind: "tagsAttributes";
        /**
         * Data regarding the tags listings
         *
         * @generated from protobuf field: bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.TagsAttributes tags_attributes = 12
         */
        tagsAttributes: ListingComponent_ListingAttributes_TagsAttributes;
    } | {
        oneofKind: undefined;
    };
    /**
     * User's active experiments in the context of current listings
     *
     * @generated from protobuf field: repeated bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.ActiveExperiment active_experiments = 13
     */
    activeExperiments: ListingComponent_ListingAttributes_ActiveExperiment[];
    /**
     * Neo chat id
     *
     * @generated from protobuf field: optional string chat_id = 14
     */
    chatId?: string;
    /**
     * Neo chat state at the launch of the page
     *
     * @generated from protobuf field: bianka.enums.listing.NeoDefaultState neo_default_state = 15
     */
    neoDefaultState: NeoDefaultState;
    /**
     * An identifier of a listing within the context of a session(built using thw following format: pageCtxId_listingId).
     *
     * @generated from protobuf field: string listing_id = 16
     */
    listingId: string;
    /**
     * Whether or not the listing was created by the assistant
     *
     * @generated from protobuf field: bool created_by_neo = 17
     */
    createdByNeo: boolean;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.ActiveFilter
 */
export interface ListingComponent_ListingAttributes_ActiveFilter {
    /**
     * Filter's name
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * List of filter's values
     *
     * @generated from protobuf field: repeated string values = 2
     */
    values: string[];
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.LastlyAppliedFilter
 */
export interface ListingComponent_ListingAttributes_LastlyAppliedFilter {
    /**
     * Filter's name
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * Filter's location/cluster in the page
     *
     * @generated from protobuf field: bianka.enums.listing.filter.SourceType source_type = 2
     */
    sourceType: SourceType;
    /**
     * Filter's layout that the user interacted with in the page
     *
     * @generated from protobuf field: bianka.enums.listing.filter.UserInputType user_input_type = 3
     */
    userInputType: UserInputType;
    /**
     * The group name that holds multiple filters (dropdown facets only)
     *
     * @generated from protobuf field: bianka.enums.listing.filter.DropdownGroupName dropdown_filters_group_name = 4
     */
    dropdownFiltersGroupName: DropdownGroupName;
    /**
     * Filter's position in its corresponding group (dropdown facets only)
     *
     * @generated from protobuf field: optional int32 dropdown_position_in_filters_group = 5
     */
    dropdownPositionInFiltersGroup?: number;
    /**
     * List of filter's values
     *
     * @generated from protobuf field: repeated bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.LastlyAppliedFilter.Value values = 6
     */
    values: ListingComponent_ListingAttributes_LastlyAppliedFilter_Value[];
    /**
     * Is the filter shown above the fold in the drawer or not.
     *
     * @generated from protobuf field: bool is_above_fold = 7
     */
    isAboveFold: boolean;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.LastlyAppliedFilter.Value
 */
export interface ListingComponent_ListingAttributes_LastlyAppliedFilter_Value {
    /**
     * Value's position inside the filter
     *
     * @generated from protobuf field: optional int32 position_in_filter = 1
     */
    positionInFilter?: number;
    /**
     * Value's value
     *
     * @generated from protobuf field: string value = 2
     */
    value: string;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes
 */
export interface ListingComponent_ListingAttributes_SearchAttributes {
    /**
     * Leaf category with the largest portion of clicks
     *
     * @generated from protobuf field: optional int32 dominant_leaf_category = 1
     */
    dominantLeafCategory?: number;
    /**
     * leaf categories (nested/sub category) that have the significant portion of clicks
     *
     * @generated from protobuf field: repeated int32 significant_leaf_categories = 2
     */
    significantLeafCategories: number[];
    /**
     * The search query
     *
     * @generated from protobuf field: string search_query = 3
     */
    searchQuery: string;
    /**
     * The modified search query
     *
     * @generated from protobuf field: optional string modified_search_query = 4
     */
    modifiedSearchQuery?: string;
    /**
     * The canonicalized search query
     *
     * @generated from protobuf field: optional string canonicalized_search_query = 5
     */
    canonicalizedSearchQuery?: string;
    /**
     * Data regarding the auto complete
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes.AutoComplete autocomplete = 6
     */
    autocomplete?: ListingComponent_ListingAttributes_SearchAttributes_AutoComplete;
    /**
     * Data regarding the related tags
     *
     * @generated from protobuf field: bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes.Related related = 7
     */
    related?: ListingComponent_ListingAttributes_SearchAttributes_Related;
    /**
     * the English machine translation of search_query
     *
     * @generated from protobuf field: optional string translated_search_query = 8
     */
    translatedSearchQuery?: string;
    /**
     * source language of search_query as identified by Machine Translation
     *
     * @generated from protobuf field: optional string query_source_language = 9
     */
    querySourceLanguage?: string;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes.AutoComplete
 */
export interface ListingComponent_ListingAttributes_SearchAttributes_AutoComplete {
    /**
     * The original term
     *
     * @generated from protobuf field: string original_term = 1
     */
    originalTerm: string;
    /**
     * Auto complete type
     *
     * @generated from protobuf field: string type = 2
     */
    type: string;
    /**
     * Auto complete position
     *
     * @generated from protobuf field: int32 position = 3
     */
    position: number;
    /**
     * Auto complete sub type of a popular tag
     *
     * @generated from protobuf field: optional string sub_type = 4
     */
    subType?: string;
    /**
     * Auto complete leaf category id
     *
     * @generated from protobuf field: optional int32 leaf_category_id = 5
     */
    leafCategoryId?: number;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes.Related
 */
export interface ListingComponent_ListingAttributes_SearchAttributes_Related {
    /**
     * position of clicked tag
     *
     * @generated from protobuf field: optional int32 position = 1
     */
    position?: number;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.CategoryAttributes
 */
export interface ListingComponent_ListingAttributes_CategoryAttributes {
    /**
     * The category id
     *
     * @generated from protobuf field: optional int32 category_id = 1
     */
    categoryId?: number;
    /**
     * The sub category id
     *
     * @generated from protobuf field: optional int32 subcategory_id = 2
     */
    subcategoryId?: number;
    /**
     * The nested sub category id
     *
     * @generated from protobuf field: optional int32 nested_subcategory_id = 3
     */
    nestedSubcategoryId?: number;
    /**
     * The leaf category id of the listing (one of the above)
     *
     * @generated from protobuf field: int32 leaf_category_id = 4
     */
    leafCategoryId: number;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.TagsAttributes
 */
export interface ListingComponent_ListingAttributes_TagsAttributes {
    /**
     * The tag that was used to generate the page
     *
     * @generated from protobuf field: string tag = 1
     */
    tag: string;
}
/**
 * @generated from protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.ActiveExperiment
 */
export interface ListingComponent_ListingAttributes_ActiveExperiment {
    /**
     * Experiment id
     *
     * @generated from protobuf field: int32 id = 1
     */
    id: number;
    /**
     * User's group in experiment
     *
     * @generated from protobuf field: int32 group = 2
     */
    group: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class ListingComponent$Type extends MessageType<ListingComponent> {
    constructor() {
        super("bianka.event.activity.v2.extension.ListingComponent", [
            { no: 1, name: "listing_attributes", kind: "message", T: () => ListingComponent_ListingAttributes }
        ]);
    }
    create(value?: PartialMessage<ListingComponent>): ListingComponent {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListingComponent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListingComponent): ListingComponent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bianka.event.activity.v2.extension.ListingComponent.ListingAttributes listing_attributes */ 1:
                    message.listingAttributes = ListingComponent_ListingAttributes.internalBinaryRead(reader, reader.uint32(), options, message.listingAttributes);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListingComponent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bianka.event.activity.v2.extension.ListingComponent.ListingAttributes listing_attributes = 1; */
        if (message.listingAttributes)
            ListingComponent_ListingAttributes.internalBinaryWrite(message.listingAttributes, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ListingComponent
 */
export const ListingComponent = new ListingComponent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListingComponent_ListingAttributes$Type extends MessageType<ListingComponent_ListingAttributes> {
    constructor() {
        super("bianka.event.activity.v2.extension.ListingComponent.ListingAttributes", [
            { no: 1, name: "results_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_num", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "sorter", kind: "enum", T: () => ["bianka.enums.listing.Sorter", Sorter, "SORTER_"] },
            { no: 4, name: "context", kind: "enum", T: () => ["bianka.enums.listing.Context", Context, "CONTEXT_"] },
            { no: 5, name: "fiverr_context", kind: "enum", T: () => ["bianka.enums.listing.FiverrContext", FiverrContext, "FIVERR_CONTEXT_"] },
            { no: 6, name: "view_type", kind: "enum", T: () => ["bianka.enums.listing.ViewType", ViewType, "VIEW_TYPE_"] },
            { no: 7, name: "toggles_list", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["bianka.enums.listing.Toggle", Toggle, "TOGGLE_"] },
            { no: 8, name: "active_filters", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListingComponent_ListingAttributes_ActiveFilter },
            { no: 9, name: "lastly_applied_filters", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListingComponent_ListingAttributes_LastlyAppliedFilter },
            { no: 10, name: "search_attributes", kind: "message", oneof: "contextAttributes", T: () => ListingComponent_ListingAttributes_SearchAttributes },
            { no: 11, name: "category_attributes", kind: "message", oneof: "contextAttributes", T: () => ListingComponent_ListingAttributes_CategoryAttributes },
            { no: 12, name: "tags_attributes", kind: "message", oneof: "contextAttributes", T: () => ListingComponent_ListingAttributes_TagsAttributes },
            { no: 13, name: "active_experiments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListingComponent_ListingAttributes_ActiveExperiment },
            { no: 14, name: "chat_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "neo_default_state", kind: "enum", T: () => ["bianka.enums.listing.NeoDefaultState", NeoDefaultState, "NEO_DEFAULT_STATE_"] },
            { no: 16, name: "listing_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "created_by_neo", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListingComponent_ListingAttributes>): ListingComponent_ListingAttributes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resultsNumber = 0;
        message.pageNum = 0;
        message.sorter = 0;
        message.context = 0;
        message.fiverrContext = 0;
        message.viewType = 0;
        message.togglesList = [];
        message.activeFilters = [];
        message.lastlyAppliedFilters = [];
        message.contextAttributes = { oneofKind: undefined };
        message.activeExperiments = [];
        message.neoDefaultState = 0;
        message.listingId = "";
        message.createdByNeo = false;
        if (value !== undefined)
            reflectionMergePartial<ListingComponent_ListingAttributes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListingComponent_ListingAttributes): ListingComponent_ListingAttributes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 results_number */ 1:
                    message.resultsNumber = reader.int32();
                    break;
                case /* int32 page_num */ 2:
                    message.pageNum = reader.int32();
                    break;
                case /* bianka.enums.listing.Sorter sorter */ 3:
                    message.sorter = reader.int32();
                    break;
                case /* bianka.enums.listing.Context context */ 4:
                    message.context = reader.int32();
                    break;
                case /* bianka.enums.listing.FiverrContext fiverr_context */ 5:
                    message.fiverrContext = reader.int32();
                    break;
                case /* bianka.enums.listing.ViewType view_type */ 6:
                    message.viewType = reader.int32();
                    break;
                case /* repeated bianka.enums.listing.Toggle toggles_list */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.togglesList.push(reader.int32());
                    else
                        message.togglesList.push(reader.int32());
                    break;
                case /* repeated bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.ActiveFilter active_filters */ 8:
                    message.activeFilters.push(ListingComponent_ListingAttributes_ActiveFilter.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.LastlyAppliedFilter lastly_applied_filters */ 9:
                    message.lastlyAppliedFilters.push(ListingComponent_ListingAttributes_LastlyAppliedFilter.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes search_attributes */ 10:
                    message.contextAttributes = {
                        oneofKind: "searchAttributes",
                        searchAttributes: ListingComponent_ListingAttributes_SearchAttributes.internalBinaryRead(reader, reader.uint32(), options, (message.contextAttributes as any).searchAttributes)
                    };
                    break;
                case /* bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.CategoryAttributes category_attributes */ 11:
                    message.contextAttributes = {
                        oneofKind: "categoryAttributes",
                        categoryAttributes: ListingComponent_ListingAttributes_CategoryAttributes.internalBinaryRead(reader, reader.uint32(), options, (message.contextAttributes as any).categoryAttributes)
                    };
                    break;
                case /* bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.TagsAttributes tags_attributes */ 12:
                    message.contextAttributes = {
                        oneofKind: "tagsAttributes",
                        tagsAttributes: ListingComponent_ListingAttributes_TagsAttributes.internalBinaryRead(reader, reader.uint32(), options, (message.contextAttributes as any).tagsAttributes)
                    };
                    break;
                case /* repeated bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.ActiveExperiment active_experiments */ 13:
                    message.activeExperiments.push(ListingComponent_ListingAttributes_ActiveExperiment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional string chat_id */ 14:
                    message.chatId = reader.string();
                    break;
                case /* bianka.enums.listing.NeoDefaultState neo_default_state */ 15:
                    message.neoDefaultState = reader.int32();
                    break;
                case /* string listing_id */ 16:
                    message.listingId = reader.string();
                    break;
                case /* bool created_by_neo */ 17:
                    message.createdByNeo = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListingComponent_ListingAttributes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 results_number = 1; */
        if (message.resultsNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.resultsNumber);
        /* int32 page_num = 2; */
        if (message.pageNum !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageNum);
        /* bianka.enums.listing.Sorter sorter = 3; */
        if (message.sorter !== 0)
            writer.tag(3, WireType.Varint).int32(message.sorter);
        /* bianka.enums.listing.Context context = 4; */
        if (message.context !== 0)
            writer.tag(4, WireType.Varint).int32(message.context);
        /* bianka.enums.listing.FiverrContext fiverr_context = 5; */
        if (message.fiverrContext !== 0)
            writer.tag(5, WireType.Varint).int32(message.fiverrContext);
        /* bianka.enums.listing.ViewType view_type = 6; */
        if (message.viewType !== 0)
            writer.tag(6, WireType.Varint).int32(message.viewType);
        /* repeated bianka.enums.listing.Toggle toggles_list = 7; */
        if (message.togglesList.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.togglesList.length; i++)
                writer.int32(message.togglesList[i]);
            writer.join();
        }
        /* repeated bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.ActiveFilter active_filters = 8; */
        for (let i = 0; i < message.activeFilters.length; i++)
            ListingComponent_ListingAttributes_ActiveFilter.internalBinaryWrite(message.activeFilters[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.LastlyAppliedFilter lastly_applied_filters = 9; */
        for (let i = 0; i < message.lastlyAppliedFilters.length; i++)
            ListingComponent_ListingAttributes_LastlyAppliedFilter.internalBinaryWrite(message.lastlyAppliedFilters[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes search_attributes = 10; */
        if (message.contextAttributes.oneofKind === "searchAttributes")
            ListingComponent_ListingAttributes_SearchAttributes.internalBinaryWrite(message.contextAttributes.searchAttributes, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.CategoryAttributes category_attributes = 11; */
        if (message.contextAttributes.oneofKind === "categoryAttributes")
            ListingComponent_ListingAttributes_CategoryAttributes.internalBinaryWrite(message.contextAttributes.categoryAttributes, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.TagsAttributes tags_attributes = 12; */
        if (message.contextAttributes.oneofKind === "tagsAttributes")
            ListingComponent_ListingAttributes_TagsAttributes.internalBinaryWrite(message.contextAttributes.tagsAttributes, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.ActiveExperiment active_experiments = 13; */
        for (let i = 0; i < message.activeExperiments.length; i++)
            ListingComponent_ListingAttributes_ActiveExperiment.internalBinaryWrite(message.activeExperiments[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* optional string chat_id = 14; */
        if (message.chatId !== undefined)
            writer.tag(14, WireType.LengthDelimited).string(message.chatId);
        /* bianka.enums.listing.NeoDefaultState neo_default_state = 15; */
        if (message.neoDefaultState !== 0)
            writer.tag(15, WireType.Varint).int32(message.neoDefaultState);
        /* string listing_id = 16; */
        if (message.listingId !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.listingId);
        /* bool created_by_neo = 17; */
        if (message.createdByNeo !== false)
            writer.tag(17, WireType.Varint).bool(message.createdByNeo);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes
 */
export const ListingComponent_ListingAttributes = new ListingComponent_ListingAttributes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListingComponent_ListingAttributes_ActiveFilter$Type extends MessageType<ListingComponent_ListingAttributes_ActiveFilter> {
    constructor() {
        super("bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.ActiveFilter", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListingComponent_ListingAttributes_ActiveFilter>): ListingComponent_ListingAttributes_ActiveFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.values = [];
        if (value !== undefined)
            reflectionMergePartial<ListingComponent_ListingAttributes_ActiveFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListingComponent_ListingAttributes_ActiveFilter): ListingComponent_ListingAttributes_ActiveFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* repeated string values */ 2:
                    message.values.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListingComponent_ListingAttributes_ActiveFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* repeated string values = 2; */
        for (let i = 0; i < message.values.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.values[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.ActiveFilter
 */
export const ListingComponent_ListingAttributes_ActiveFilter = new ListingComponent_ListingAttributes_ActiveFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListingComponent_ListingAttributes_LastlyAppliedFilter$Type extends MessageType<ListingComponent_ListingAttributes_LastlyAppliedFilter> {
    constructor() {
        super("bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.LastlyAppliedFilter", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "source_type", kind: "enum", T: () => ["bianka.enums.listing.filter.SourceType", SourceType, "SOURCE_TYPE_"] },
            { no: 3, name: "user_input_type", kind: "enum", T: () => ["bianka.enums.listing.filter.UserInputType", UserInputType, "USER_INPUT_TYPE_"] },
            { no: 4, name: "dropdown_filters_group_name", kind: "enum", T: () => ["bianka.enums.listing.filter.DropdownGroupName", DropdownGroupName, "DROPDOWN_GROUP_NAME_"] },
            { no: 5, name: "dropdown_position_in_filters_group", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListingComponent_ListingAttributes_LastlyAppliedFilter_Value },
            { no: 7, name: "is_above_fold", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ListingComponent_ListingAttributes_LastlyAppliedFilter>): ListingComponent_ListingAttributes_LastlyAppliedFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.sourceType = 0;
        message.userInputType = 0;
        message.dropdownFiltersGroupName = 0;
        message.values = [];
        message.isAboveFold = false;
        if (value !== undefined)
            reflectionMergePartial<ListingComponent_ListingAttributes_LastlyAppliedFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListingComponent_ListingAttributes_LastlyAppliedFilter): ListingComponent_ListingAttributes_LastlyAppliedFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* bianka.enums.listing.filter.SourceType source_type */ 2:
                    message.sourceType = reader.int32();
                    break;
                case /* bianka.enums.listing.filter.UserInputType user_input_type */ 3:
                    message.userInputType = reader.int32();
                    break;
                case /* bianka.enums.listing.filter.DropdownGroupName dropdown_filters_group_name */ 4:
                    message.dropdownFiltersGroupName = reader.int32();
                    break;
                case /* optional int32 dropdown_position_in_filters_group */ 5:
                    message.dropdownPositionInFiltersGroup = reader.int32();
                    break;
                case /* repeated bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.LastlyAppliedFilter.Value values */ 6:
                    message.values.push(ListingComponent_ListingAttributes_LastlyAppliedFilter_Value.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool is_above_fold */ 7:
                    message.isAboveFold = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListingComponent_ListingAttributes_LastlyAppliedFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* bianka.enums.listing.filter.SourceType source_type = 2; */
        if (message.sourceType !== 0)
            writer.tag(2, WireType.Varint).int32(message.sourceType);
        /* bianka.enums.listing.filter.UserInputType user_input_type = 3; */
        if (message.userInputType !== 0)
            writer.tag(3, WireType.Varint).int32(message.userInputType);
        /* bianka.enums.listing.filter.DropdownGroupName dropdown_filters_group_name = 4; */
        if (message.dropdownFiltersGroupName !== 0)
            writer.tag(4, WireType.Varint).int32(message.dropdownFiltersGroupName);
        /* optional int32 dropdown_position_in_filters_group = 5; */
        if (message.dropdownPositionInFiltersGroup !== undefined)
            writer.tag(5, WireType.Varint).int32(message.dropdownPositionInFiltersGroup);
        /* repeated bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.LastlyAppliedFilter.Value values = 6; */
        for (let i = 0; i < message.values.length; i++)
            ListingComponent_ListingAttributes_LastlyAppliedFilter_Value.internalBinaryWrite(message.values[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool is_above_fold = 7; */
        if (message.isAboveFold !== false)
            writer.tag(7, WireType.Varint).bool(message.isAboveFold);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.LastlyAppliedFilter
 */
export const ListingComponent_ListingAttributes_LastlyAppliedFilter = new ListingComponent_ListingAttributes_LastlyAppliedFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListingComponent_ListingAttributes_LastlyAppliedFilter_Value$Type extends MessageType<ListingComponent_ListingAttributes_LastlyAppliedFilter_Value> {
    constructor() {
        super("bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.LastlyAppliedFilter.Value", [
            { no: 1, name: "position_in_filter", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListingComponent_ListingAttributes_LastlyAppliedFilter_Value>): ListingComponent_ListingAttributes_LastlyAppliedFilter_Value {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<ListingComponent_ListingAttributes_LastlyAppliedFilter_Value>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListingComponent_ListingAttributes_LastlyAppliedFilter_Value): ListingComponent_ListingAttributes_LastlyAppliedFilter_Value {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int32 position_in_filter */ 1:
                    message.positionInFilter = reader.int32();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListingComponent_ListingAttributes_LastlyAppliedFilter_Value, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional int32 position_in_filter = 1; */
        if (message.positionInFilter !== undefined)
            writer.tag(1, WireType.Varint).int32(message.positionInFilter);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.LastlyAppliedFilter.Value
 */
export const ListingComponent_ListingAttributes_LastlyAppliedFilter_Value = new ListingComponent_ListingAttributes_LastlyAppliedFilter_Value$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListingComponent_ListingAttributes_SearchAttributes$Type extends MessageType<ListingComponent_ListingAttributes_SearchAttributes> {
    constructor() {
        super("bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes", [
            { no: 1, name: "dominant_leaf_category", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "significant_leaf_categories", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "search_query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "modified_search_query", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "canonicalized_search_query", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "autocomplete", kind: "message", T: () => ListingComponent_ListingAttributes_SearchAttributes_AutoComplete },
            { no: 7, name: "related", kind: "message", T: () => ListingComponent_ListingAttributes_SearchAttributes_Related },
            { no: 8, name: "translated_search_query", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "query_source_language", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListingComponent_ListingAttributes_SearchAttributes>): ListingComponent_ListingAttributes_SearchAttributes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.significantLeafCategories = [];
        message.searchQuery = "";
        if (value !== undefined)
            reflectionMergePartial<ListingComponent_ListingAttributes_SearchAttributes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListingComponent_ListingAttributes_SearchAttributes): ListingComponent_ListingAttributes_SearchAttributes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int32 dominant_leaf_category */ 1:
                    message.dominantLeafCategory = reader.int32();
                    break;
                case /* repeated int32 significant_leaf_categories */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.significantLeafCategories.push(reader.int32());
                    else
                        message.significantLeafCategories.push(reader.int32());
                    break;
                case /* string search_query */ 3:
                    message.searchQuery = reader.string();
                    break;
                case /* optional string modified_search_query */ 4:
                    message.modifiedSearchQuery = reader.string();
                    break;
                case /* optional string canonicalized_search_query */ 5:
                    message.canonicalizedSearchQuery = reader.string();
                    break;
                case /* bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes.AutoComplete autocomplete */ 6:
                    message.autocomplete = ListingComponent_ListingAttributes_SearchAttributes_AutoComplete.internalBinaryRead(reader, reader.uint32(), options, message.autocomplete);
                    break;
                case /* bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes.Related related */ 7:
                    message.related = ListingComponent_ListingAttributes_SearchAttributes_Related.internalBinaryRead(reader, reader.uint32(), options, message.related);
                    break;
                case /* optional string translated_search_query */ 8:
                    message.translatedSearchQuery = reader.string();
                    break;
                case /* optional string query_source_language */ 9:
                    message.querySourceLanguage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListingComponent_ListingAttributes_SearchAttributes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional int32 dominant_leaf_category = 1; */
        if (message.dominantLeafCategory !== undefined)
            writer.tag(1, WireType.Varint).int32(message.dominantLeafCategory);
        /* repeated int32 significant_leaf_categories = 2; */
        if (message.significantLeafCategories.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.significantLeafCategories.length; i++)
                writer.int32(message.significantLeafCategories[i]);
            writer.join();
        }
        /* string search_query = 3; */
        if (message.searchQuery !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.searchQuery);
        /* optional string modified_search_query = 4; */
        if (message.modifiedSearchQuery !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.modifiedSearchQuery);
        /* optional string canonicalized_search_query = 5; */
        if (message.canonicalizedSearchQuery !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.canonicalizedSearchQuery);
        /* bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes.AutoComplete autocomplete = 6; */
        if (message.autocomplete)
            ListingComponent_ListingAttributes_SearchAttributes_AutoComplete.internalBinaryWrite(message.autocomplete, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes.Related related = 7; */
        if (message.related)
            ListingComponent_ListingAttributes_SearchAttributes_Related.internalBinaryWrite(message.related, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional string translated_search_query = 8; */
        if (message.translatedSearchQuery !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.translatedSearchQuery);
        /* optional string query_source_language = 9; */
        if (message.querySourceLanguage !== undefined)
            writer.tag(9, WireType.LengthDelimited).string(message.querySourceLanguage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes
 */
export const ListingComponent_ListingAttributes_SearchAttributes = new ListingComponent_ListingAttributes_SearchAttributes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListingComponent_ListingAttributes_SearchAttributes_AutoComplete$Type extends MessageType<ListingComponent_ListingAttributes_SearchAttributes_AutoComplete> {
    constructor() {
        super("bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes.AutoComplete", [
            { no: 1, name: "original_term", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "position", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "sub_type", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "leaf_category_id", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ListingComponent_ListingAttributes_SearchAttributes_AutoComplete>): ListingComponent_ListingAttributes_SearchAttributes_AutoComplete {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.originalTerm = "";
        message.type = "";
        message.position = 0;
        if (value !== undefined)
            reflectionMergePartial<ListingComponent_ListingAttributes_SearchAttributes_AutoComplete>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListingComponent_ListingAttributes_SearchAttributes_AutoComplete): ListingComponent_ListingAttributes_SearchAttributes_AutoComplete {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string original_term */ 1:
                    message.originalTerm = reader.string();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* int32 position */ 3:
                    message.position = reader.int32();
                    break;
                case /* optional string sub_type */ 4:
                    message.subType = reader.string();
                    break;
                case /* optional int32 leaf_category_id */ 5:
                    message.leafCategoryId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListingComponent_ListingAttributes_SearchAttributes_AutoComplete, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string original_term = 1; */
        if (message.originalTerm !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.originalTerm);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* int32 position = 3; */
        if (message.position !== 0)
            writer.tag(3, WireType.Varint).int32(message.position);
        /* optional string sub_type = 4; */
        if (message.subType !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.subType);
        /* optional int32 leaf_category_id = 5; */
        if (message.leafCategoryId !== undefined)
            writer.tag(5, WireType.Varint).int32(message.leafCategoryId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes.AutoComplete
 */
export const ListingComponent_ListingAttributes_SearchAttributes_AutoComplete = new ListingComponent_ListingAttributes_SearchAttributes_AutoComplete$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListingComponent_ListingAttributes_SearchAttributes_Related$Type extends MessageType<ListingComponent_ListingAttributes_SearchAttributes_Related> {
    constructor() {
        super("bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes.Related", [
            { no: 1, name: "position", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ListingComponent_ListingAttributes_SearchAttributes_Related>): ListingComponent_ListingAttributes_SearchAttributes_Related {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListingComponent_ListingAttributes_SearchAttributes_Related>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListingComponent_ListingAttributes_SearchAttributes_Related): ListingComponent_ListingAttributes_SearchAttributes_Related {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int32 position */ 1:
                    message.position = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListingComponent_ListingAttributes_SearchAttributes_Related, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional int32 position = 1; */
        if (message.position !== undefined)
            writer.tag(1, WireType.Varint).int32(message.position);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.SearchAttributes.Related
 */
export const ListingComponent_ListingAttributes_SearchAttributes_Related = new ListingComponent_ListingAttributes_SearchAttributes_Related$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListingComponent_ListingAttributes_CategoryAttributes$Type extends MessageType<ListingComponent_ListingAttributes_CategoryAttributes> {
    constructor() {
        super("bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.CategoryAttributes", [
            { no: 1, name: "category_id", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "subcategory_id", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "nested_subcategory_id", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "leaf_category_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ListingComponent_ListingAttributes_CategoryAttributes>): ListingComponent_ListingAttributes_CategoryAttributes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.leafCategoryId = 0;
        if (value !== undefined)
            reflectionMergePartial<ListingComponent_ListingAttributes_CategoryAttributes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListingComponent_ListingAttributes_CategoryAttributes): ListingComponent_ListingAttributes_CategoryAttributes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional int32 category_id */ 1:
                    message.categoryId = reader.int32();
                    break;
                case /* optional int32 subcategory_id */ 2:
                    message.subcategoryId = reader.int32();
                    break;
                case /* optional int32 nested_subcategory_id */ 3:
                    message.nestedSubcategoryId = reader.int32();
                    break;
                case /* int32 leaf_category_id */ 4:
                    message.leafCategoryId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListingComponent_ListingAttributes_CategoryAttributes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional int32 category_id = 1; */
        if (message.categoryId !== undefined)
            writer.tag(1, WireType.Varint).int32(message.categoryId);
        /* optional int32 subcategory_id = 2; */
        if (message.subcategoryId !== undefined)
            writer.tag(2, WireType.Varint).int32(message.subcategoryId);
        /* optional int32 nested_subcategory_id = 3; */
        if (message.nestedSubcategoryId !== undefined)
            writer.tag(3, WireType.Varint).int32(message.nestedSubcategoryId);
        /* int32 leaf_category_id = 4; */
        if (message.leafCategoryId !== 0)
            writer.tag(4, WireType.Varint).int32(message.leafCategoryId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.CategoryAttributes
 */
export const ListingComponent_ListingAttributes_CategoryAttributes = new ListingComponent_ListingAttributes_CategoryAttributes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListingComponent_ListingAttributes_TagsAttributes$Type extends MessageType<ListingComponent_ListingAttributes_TagsAttributes> {
    constructor() {
        super("bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.TagsAttributes", [
            { no: 1, name: "tag", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListingComponent_ListingAttributes_TagsAttributes>): ListingComponent_ListingAttributes_TagsAttributes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tag = "";
        if (value !== undefined)
            reflectionMergePartial<ListingComponent_ListingAttributes_TagsAttributes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListingComponent_ListingAttributes_TagsAttributes): ListingComponent_ListingAttributes_TagsAttributes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tag */ 1:
                    message.tag = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListingComponent_ListingAttributes_TagsAttributes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string tag = 1; */
        if (message.tag !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tag);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.TagsAttributes
 */
export const ListingComponent_ListingAttributes_TagsAttributes = new ListingComponent_ListingAttributes_TagsAttributes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListingComponent_ListingAttributes_ActiveExperiment$Type extends MessageType<ListingComponent_ListingAttributes_ActiveExperiment> {
    constructor() {
        super("bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.ActiveExperiment", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "group", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ListingComponent_ListingAttributes_ActiveExperiment>): ListingComponent_ListingAttributes_ActiveExperiment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.group = 0;
        if (value !== undefined)
            reflectionMergePartial<ListingComponent_ListingAttributes_ActiveExperiment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListingComponent_ListingAttributes_ActiveExperiment): ListingComponent_ListingAttributes_ActiveExperiment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 group */ 2:
                    message.group = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListingComponent_ListingAttributes_ActiveExperiment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 group = 2; */
        if (message.group !== 0)
            writer.tag(2, WireType.Varint).int32(message.group);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.event.activity.v2.extension.ListingComponent.ListingAttributes.ActiveExperiment
 */
export const ListingComponent_ListingAttributes_ActiveExperiment = new ListingComponent_ListingAttributes_ActiveExperiment$Type();
